var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid } from '@mui/material';
import { toEditableBid, toEditableOrderItem, } from '../../../hooks/useOrder';
import { useRequest } from '../../../hooks/requestHook';
import { useNotify } from '../../../hooks/notificationHook';
import { useBidColumns, useOrderItemColumns, isBidEditable, useBidActions, } from '../../../hooks/useColumns';
import { order as orderApi, bid as bidApi } from '../../../api';
import MaterialTable from '../../MaterialTable';
import OriginalEditField from '../../MaterialTable/EditField';
import MultilineTextField from '../../MaterialTable/MultilineTextField';
import OrderForm from './OrderForm';
import OfferListLinks from '../../molecules/OfferListLinks';
import LabeledGridItem from '../../atoms/LabeledGridItem';
import OrderStatus from './OrderStatus';
var EditField = function (props) {
    switch (props.columnDef.field) {
        case 'comment':
            return React.createElement(MultilineTextField, __assign({}, props));
        default:
            return React.createElement(OriginalEditField, __assign({}, props));
    }
};
var OrderContent = function (_a) {
    var loading = _a.loading, setLoading = _a.setLoading, order = _a.order, orderItems = _a.orderItems, bids = _a.bids, onOrderChanged = _a.onOrderChanged, onOrderItemChanged = _a.onOrderItemChanged, onBidChanged = _a.onBidChanged, _b = _a.isUSRoaster, isUSRoaster = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var notify = useNotify();
    var updateItem = useRequest(orderApi.updateItem);
    var updateBid = useRequest(bidApi.update);
    var destroyBid = useRequest(bidApi.destroy);
    var OrderItemColumns = useOrderItemColumns({
        role: 'admin',
        currency: order.roaster.country.currency,
    });
    var BidColumns = useBidColumns({ linkPrefix: '/admin' });
    var BidActions = useBidActions({ role: 'admin' });
    var orderItemColumns = React.useMemo(function () { return [
        OrderItemColumns.lotNumber,
        OrderItemColumns.quantity,
        OrderItemColumns.subTotalDiscount,
        OrderItemColumns.typicaHandlingFeeDiscount,
        OrderItemColumns.totalFeeDiscount,
        OrderItemColumns.comment,
        OrderItemColumns.isPreOrderRequested,
        OrderItemColumns.isSentPreOrderMail,
    ]; }, [OrderItemColumns]);
    var bidColumns = React.useMemo(function () { return [
        BidColumns.lotNumber,
        isUSRoaster ? BidColumns.fobPriceUsdPerLb : BidColumns.fobPrice,
        BidColumns.quantity,
        BidColumns.buyPartial,
        BidColumns.bidAt,
        BidColumns.status,
    ]; }, [BidColumns, isUSRoaster]);
    var handleUpdateOrderItem = React.useCallback(function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, updateItem({
                            id: item.id,
                            order_id: order.id,
                            order_item: {
                                quantity: item.quantity,
                                comment: item.comment || '',
                                sub_total_discount: item.subTotalDiscount,
                                typica_handling_fee_discount: item.typicaHandlingFeeDiscount,
                                total_fee_discount: item.totalFeeDiscount,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        throw Error('response error');
                    onOrderItemChanged(response);
                    onOrderChanged(response.order);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [
        t,
        order,
        setLoading,
        notify,
        updateItem,
        onOrderChanged,
        onOrderItemChanged,
    ]);
    var handleUpdateBid = React.useCallback(function (bid) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, updateBid({
                            id: bid.id,
                            bid: {
                                fob_price: bid.fobPrice,
                                fob_price_usd_per_lb: bid.fobPriceUsdPerLb,
                                quantity: bid.quantity,
                                buy_partial: bid.buyPartial,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        throw Error('response error');
                    onBidChanged(response);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, setLoading, notify, updateBid, onBidChanged]);
    var handleRejectBid = React.useCallback(function (bid) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, destroyBid({ id: bid.id })];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/];
                    onBidChanged(response);
                    onOrderChanged(response.order);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, setLoading, notify, destroyBid, onOrderChanged, onBidChanged]);
    var editable = React.useMemo(function () {
        if (!order)
            return;
        var _a = order.offerLists, offerLists = _a === void 0 ? [] : _a, status = order.status;
        if (status === 'canceled')
            return;
        if (offerLists.every(function (_a) {
            var fixed = _a.fixed;
            return fixed;
        }) && status === 'confirmed')
            return;
        return { onRowUpdate: handleUpdateOrderItem };
    }, [order, handleUpdateOrderItem]);
    var editableOrderItems = orderItems.map(toEditableOrderItem);
    var editableBids = bids.map(toEditableBid);
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(LabeledGridItem, { label: t('params.offerList.name'), value: React.createElement(OfferListLinks, { pathPrefix: "/admin", offerLists: order.offerLists }) }),
            React.createElement(LabeledGridItem, { label: t('params.roaster.name'), value: t('fullname', order.roaster) }),
            React.createElement(LabeledGridItem, { label: t('params.order.status'), value: React.createElement(OrderStatus, { order: order, onOrderChanged: onOrderChanged }) })),
        React.createElement(OrderForm, { order: order, editable: Boolean(editable), onOrderChanged: onOrderChanged }),
        React.createElement(MaterialTable, { model: "orderItem", title: t('pages.orderDetail.orderItemsTableTitle'), isLoading: loading, columns: orderItemColumns, data: editableOrderItems, editable: editable, components: {
                EditField: EditField,
            }, options: {
                minBodyHeight: 0,
            } }),
        React.createElement(Box, { mt: 2 }),
        React.createElement(MaterialTable, { model: "bid", title: t('pages.orderDetail.bidsTableTitle'), isLoading: loading, columns: bidColumns, actions: [BidActions.linkToAuction], data: editableBids, editable: {
                isEditable: isBidEditable,
                onRowUpdate: handleUpdateBid,
                isDeletable: isBidEditable,
                onRowDelete: handleRejectBid,
                deleteTooltip: function () { return 'reject'; },
            }, components: {
                EditField: EditField,
            }, options: {
                minBodyHeight: 0,
            }, localization: {
                header: {
                    actions: '',
                },
                body: {
                    emptyDataSourceMessage: t('labels.noData'),
                    editRow: {
                        deleteText: t('messages.rejectConfirm'),
                    },
                },
            } })));
};
export default OrderContent;
